import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent, DialogService, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';

import { Truck } from '../../truck-overview/truck.model';
import { TruckDetailsDialogComponent } from '../../truck/component/truck-details-dialog/truck-details-dialog.component';
import { TruckDetails } from '../../truck/truck.model';
import { TruckService } from '../../truck/truck.service';
import { TruckGcCaseDialogComponent } from '../../../../components/visit-overview/component/truck-gc-case-dialog/truck-gc-case-dialog.component';

@Component({
  selector: 'app-truck-overview-action-bar',
  templateUrl: './truck-overview-action-bar.component.html',
  styleUrls: ['./truck-overview-action-bar.component.scss']
})
export class TruckOverviewActionBarComponent extends AbstractWidgetComponent implements OnInit {


  truck: Truck;

  editTruckEnabled = false;
  leaveTruckEnabled = false;
  showGcCaseEnabled = false;

  constructor(
    public translationService: TranslationService,
    public configurationService: AppClientConfigurationService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private truckService: TruckService
  ) {
    super();
    this.updateActionStatus();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selected-truck') {
      this.truck = contextChange.value;
      this.updateActionStatus();
    }
  }

  onSetElementAndContext() { }

  private updateActionStatus() {
    this.leaveTruckEnabled = this.truck != null && this.truck.id != null;
    this.editTruckEnabled = this.truck != null && this.truck.id != null;
    this.showGcCaseEnabled = this.truck != null && this.truck.messagingReference != null;
  }

  public registerTruck() {
    const truck = new TruckDetails();

    const dialogRef = this.dialog.open(TruckDetailsDialogComponent, {
      data: { model: truck, action: 'new' }
    });
    dialogRef.afterClosed().subscribe(() => this.reloadTruckList());
  }

  public editTruck() {
    if (!this.editTruckEnabled) {
      return;
    }
    this.truckService.getTruckDetails(this.truck.id).subscribe(result => {
      const dialogRef = this.dialog.open(TruckDetailsDialogComponent, {
        data: { model: new TruckDetails(result), action: 'edit' }
      });
      dialogRef.afterClosed().subscribe(() => this.reloadTruckList());
    });
  }

  public leave() {

    if (!this.leaveTruckEnabled) {
      return;
    }

    this.truckService.checkLeaveAllowed(this.truck.id).subscribe(r => {
      if (r.status === ResponseStatus.SUCCESS) {
        this.handleLeaveConfirm(this.truck.id);
      } else { // We expect, that we have warnings to display
        this.dialogService.showInfoDialog('tmc-yard.ui.control.truck.dialog.leave.title',
          'tmc-yard.ui.control.truck.dialog.leave.message.failed',
          r.responseMessages.map(m => m.dictionaryKey));
      }
    });
  }

  public showGcCase() {
    if (!this.showGcCaseEnabled) {
      return;
    }

    this.dialog.open(TruckGcCaseDialogComponent, {
      height: '95%',
      width: '95%',
      maxWidth: '800px',
      maxHeight: '600px',
      data: { truck: this.truck }
    });
  }

  /** Opens a confirmation dialog the user must confirm the leave. */
  private handleLeaveConfirm(truckId: number) {

    this.dialogService.showConfirm(
      'tmc-yard.ui.control.truck.dialog.leave.title',
      'tmc-yard.ui.control.truck.dialog.leave.message'
    ).afterClosed().subscribe(() => { this.executeLeave(truckId); });


  }

  /** Executed the actual leave of the visit. */
  private executeLeave(truckId: number) {
    this.truckService.registerLeave(truckId).subscribe(r => {
      if (r.status === ResponseStatus.SUCCESS) {
        this.reloadTruckList();
      } else {
        this.dialogService.showInfoDialog('tmc-yard.ui.control.truck.dialog.leave.title',
          'tmc-yard.ui.control.truck.dialog.leave.message.failed',
          r.responseMessages.map(m => m.dictionaryKey));
      }
    });
  }

  private reloadTruckList() {
    this.dashboardContext.setContextValue('truck-changed', new Date().getTime());
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
